<div [ngClass]="{ 'dark text-white-dark': store.semidark }">
  <nav
    class="sidebar fixed bottom-0 top-0 z-50 h-full max-lg:h-svh max-lg:max-h-svh w-[220px] shadow-[5px_0_25px_0_rgba(94,92,154,0.1)] transition-all duration-300"
  >
    <div class="relative h-full bg-[#0E121B] pb-5 lg:min-h-screen">
      <div class="flex items-center justify-between px-4 py-3">
        <a class="main-logo relative flex shrink-0 items-center">
          <img
            routerLink="/"
            class="w-7 flex-none cursor-pointer"
            src="/assets/images/p2p-images/logo/logo.png"
            alt=""
          />

          <span
            class="absolute left-10 z-0 !m-0 align-middle text-2xl font-bold text-white dark:text-white-light lg:inline ltr:ml-1.5 rtl:mr-1.5"
            >Source<span class="text-[#068CFE]">by</span></span
          >
        </a>
        <a
          href="javascript:;"
          class="collapse-icon hidden h-8 w-8 items-center rounded-full text-white transition duration-300 hover:bg-gray-500/10 hover:text-primary dark:text-white-light dark:hover:bg-dark-light/10 lg:flex rtl:rotate-180"
          (click)="
            storeData.dispatch({
              type: 'toggleMenu',
              payload: 'collapsed-default'
            })
          "
        >
          <svg
            class="m-auto h-5 w-5"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13 19L7 12L13 5"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              opacity="0.5"
              d="M16.9998 19L10.9998 12L16.9998 5"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </a>
      </div>
      <div
        class="vertcal-sidebar relative !h-[calc(100vh-80px)] max-lg:!h-[calc(100svh-80px)]"
        appearance="compact"
        #sidebarScroll
      >
        <ul class="relative space-y-0.5 p-2 py-0 font-semibold">
          <!-- Dashboard -->
           @if(moduleAccessService.hasModuleAccess('dashboard')){
            <li class="accordion menu nav-item">
              <button
                type="button"
                class="nav-link group w-full"
                routerLink="/dashboard"
                routerLinkActive="active"
                [ngClass]="{ active: activeDropdown.includes('Dashboard') }"
                (click)="onNavClick('Dashboard', $event)"
                [attr.data-tooltip]="isCollapsed ? 'Dashboard' : null"
              >
                <div class="flex items-center">
                  <icon-menu-dashboard
                    class="shrink-0 !text-[#C6C7C9] group-hover:!text-[#ffffff]"
                  ></icon-menu-dashboard>
                  <span
                    class="menu-name text-white dark:text-[#adadad] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3"
                    >Dashboard</span
                  >
                </div>
              </button>
            </li>
           }
        
          <!-- Explore Vendors -->
          @if(moduleAccessService.hasModuleAccess('explore-vendor')){
          <li class="accordion menu nav-item">
            <button
              type="button"
              class="nav-link group w-full"
              routerLink="/explore-vendor-master/explore-vendor"
              routerLinkActive="active"
              [ngClass]="{ active: activeDropdown.includes('Explore Vendors') }"
              (click)="onNavClick('Explore Vendors', $event)"
              [attr.data-tooltip]="isCollapsed ? 'Explore Vendors' : null"
            >
              <div class="flex items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                >
                  <path
                    id="member-search"
                    d="M7.513,10A5,5,0,1,0,2.5,5,5.009,5.009,0,0,0,7.513,10Zm0-8.333A3.333,3.333,0,1,1,4.174,5,3.34,3.34,0,0,1,7.513,1.667ZM20,18.788l-3.165-3.16a4.188,4.188,0,1,0-1.18,1.178l3.165,3.16Zm-6.644-2.954a2.5,2.5,0,1,1,2.5-2.5A2.505,2.505,0,0,1,13.356,15.833Zm-5.6-4.167a5.816,5.816,0,0,0-.245,1.667H4.174a2.505,2.505,0,0,0-2.5,2.5V20H0V15.833a4.175,4.175,0,0,1,4.174-4.167Z"
                    fill="#c6c7c9"
                  />
                </svg>
                <span
                  class="menu-name text-white dark:text-[#adadad] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3"
                  >Explore Vendors</span
                >
              </div>
            </button>
          </li>
          }
          <!-- Event -->
          @if(moduleAccessService.hasModuleAccess('event')){
          <li class="accordion menu nav-item">
            <button
              type="button"
              class="nav-link group w-full"
              routerLink="/event-master/event-list"
              routerLinkActive="active"
              [ngClass]="{ active: activeDropdown.includes('event') }"
              (click)="onNavClick('event', $event)"
              [attr.data-tooltip]="isCollapsed ? 'Event' : null"
            >
              <div class="flex items-center">
                <icon-event
                  class="shrink-0 !text-[#C6C7C9] group-hover:!text-[#ffffff]"
                ></icon-event>

                <span
                  class="text-white dark:text-[#adadad] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3"
                >
                  Event
                </span>
              </div>
            </button>
          </li>
          }
          @if(permissionService.hasModuleOrSubModuleAccess('purchase-order','purchase-order-list')){
          <!-- Purchase Order -->
          <li class="accordion menu nav-item">
            <button
              type="button"
              class="nav-link group w-full"
              routerLink="/purchase-order-master/purchase-order-list"
              [ngClass]="{ active: activeDropdown.includes('Purchase Order') }"
              (click)="onNavClick('Purchase Order', $event)"
              routerLinkActive="active"
              [attr.data-tooltip]="isCollapsed ? 'Purchase Order' : null"
            >
              <div class="flex items-center">
                <icon-gen-po
                  class="h-4 w-4 shrink-0 !text-[#C6C7C9] group-hover:!text-[#ffffff]"
                ></icon-gen-po>

                <span
                  class="menu-name text-white dark:text-[#adadad] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3"
                  >Purchase Order
                </span>
              </div>
              </button>
            </li>
          }
          @if(showAdminCenter()){
          <!-- admin master -->
          <li class="accordion menu nav-item">
            <button
              type="button"
              class="nav-link group w-full"
    
              routerLinkActive="active"
              data-menu-name="AdminMaster"
              [ngClass]="{ active: activeDropdown.includes('AdminMaster') }"
              (click)="onNavClick('AdminMaster', $event)"
            >
              <div class="flex items-center justify-center">
                <icon-apps
                  class="shrink-0 !text-[#C6C7C9] group-hover:!text-[#ffffff]"
                ></icon-apps>

                <span
                  class="text-white dark:text-[#adadad] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3"
                >
                  Admin Center
                </span>
              </div>
              <div
                class="arrow text-white duration-200 rtl:rotate-180"
                [ngClass]="{
                  '!rotate-90': activeDropdown.includes('AdminMaster')
                }"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9 5L15 12L9 19"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </button>
            <div
              [@slideDownUp]="!activeDropdown.includes('AdminMaster')"
              class="accordion-content side-menu sub-menu-admin for-nested"
            >
              <ul class="sub-menu">
                <li
                  class="purchase-header border-b border-gray-200 pb-1 dark:border-white/10"
                >
                  <a class="flex items-center gap-2 text-primary">
                    <icon-apps
                      class="h-4 w-4 shrink-0 !text-[#6D03FE]"
                    ></icon-apps>
                    Admin Center</a
                  >
                </li>

                @if(moduleAccessService.hasModuleAccess('contract')){
                <li>
                  <a
                    routerLink="/admin-center/contract-management"
                    class="flex items-center gap-2"
                    routerLinkActive="active"
                    (click)="toggleMobileMenu()"
                    ><icon-contract-signature
                      class="h-4 w-4"
                    ></icon-contract-signature
                    >Contract</a
                  >
                </li>
                }
                @if(permissionService.hasModuleOrSubModuleAccess('contract', 'contract-template')){
                <li>
                  <a
                    routerLink="/admin-center/contract-template-list"
                    class="flex items-center gap-2"
                    routerLinkActive="active"
                    (click)="toggleMobileMenu()"
                  >
                    <svg
                      class="h-4 w-4"
                      xmlns="http://www.w3.org/2000/svg"
                      width="16.674"
                      height="20"
                      viewBox="0 0 16.674 20"
                    >
                      <path
                        id="cont-template"
                        d="M16.965,4.62l-2.9-2.9A5.8,5.8,0,0,0,9.937.01H6.168A4.157,4.157,0,0,0,2,4.17V15.842A4.17,4.17,0,0,0,6.168,20.01h8.337a4.17,4.17,0,0,0,4.168-4.168V8.747A5.8,5.8,0,0,0,16.965,4.62ZM15.789,5.8a4.237,4.237,0,0,1,.675.875H12.846a.836.836,0,0,1-.834-.834V2.219a4.237,4.237,0,0,1,.875.675Zm1.217,10.046a2.508,2.508,0,0,1-2.5,2.5H6.168a2.508,2.508,0,0,1-2.5-2.5V4.17a2.508,2.508,0,0,1,2.5-2.5h3.76a3.348,3.348,0,0,1,.409.017V5.837a2.508,2.508,0,0,0,2.5,2.5H16.99a3.28,3.28,0,0,1,.017.409Zm-3.752-5.836H7.419A2.085,2.085,0,0,0,5.335,12.09v2.5a2.085,2.085,0,0,0,2.084,2.084h5.836a2.085,2.085,0,0,0,2.084-2.084v-2.5A2.085,2.085,0,0,0,13.255,10.006Zm.417,4.585a.413.413,0,0,1-.417.417H7.419A.413.413,0,0,1,7,14.591v-2.5a.413.413,0,0,1,.417-.417h5.836a.413.413,0,0,1,.417.417ZM5.335,7.5a.836.836,0,0,1,.834-.834H7.836a.834.834,0,0,1,0,1.667H6.168A.836.836,0,0,1,5.335,7.5Z"
                        transform="translate(-2 -0.01)"
                        fill="currentColor"
                      /></svg>Contract Templates</a
                  >
                </li>
                }
                @if(permissionService.hasModuleOrSubModuleAccess('event', 'template-builder')){
                <li>
                  <a
                    routerLink="/admin-center/template-builder"
                    class="flex items-center gap-2"
                    routerLinkActive="active"
                    (click)="toggleMobileMenu()"
                  >
                    <svg
                      class="h-4 w-4"
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16.001"
                      viewBox="0 0 16 16.001"
                    >
                      <path
                        id="temp-build"
                        d="M12.542,6.667a.667.667,0,0,0,.646-.832A4.67,4.67,0,0,0,11.966,3.69L9.643,1.367A4.636,4.636,0,0,0,6.343,0H3.333A3.337,3.337,0,0,0,0,3.333v9.333A3.337,3.337,0,0,0,3.333,16h2a.667.667,0,1,0,0-1.333h-2a2,2,0,0,1-2-2V3.333a2,2,0,0,1,2-2h3.01c.109,0,.217.005.323.015V4.667a2,2,0,0,0,2,2ZM8,4.667V1.773a3.358,3.358,0,0,1,.7.537l2.323,2.323a3.363,3.363,0,0,1,.535.7H8.667A.668.668,0,0,1,8,4.667Zm7.415,3.253a2.047,2.047,0,0,0-2.829,0L8.115,12.391a2.651,2.651,0,0,0-.781,1.886v1.057A.667.667,0,0,0,8,16H9.057a2.649,2.649,0,0,0,1.885-.781l4.471-4.471a2,2,0,0,0,0-2.829ZM14.471,9.8,10,14.276a1.322,1.322,0,0,1-.943.391H8.666v-.391a1.324,1.324,0,0,1,.391-.943l4.472-4.471a.682.682,0,0,1,.943,0,.666.666,0,0,1,0,.943Z"
                        fill="currentColor"
                      />
                    </svg>
                    Template Builder</a
                  >
                </li>
                }
                @if(permissionService.hasModuleOrSubModuleAccess('event', 'form-builder')){
                <li>
                  <a
                    routerLink="/admin-center/form-builder"
                    class="flex items-center gap-2"
                    routerLinkActive="active"
                    (click)="toggleMobileMenu()"
                  >
                    <svg
                      class="h-4 w-4"
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                    >
                      <path
                        id="form-build"
                        d="M14,0H2A2,2,0,0,0,0,2V14a2,2,0,0,0,2,2H14a2,2,0,0,0,2-2V2A2,2,0,0,0,14,0ZM2,14V2H14V14ZM4,4h8V5H4Zm0,2h8V7H4Zm0,2h6V9H4Zm0,2h4V11H4Z"
                        fill="currentColor"
                      />
                    </svg>
                    Form Builder</a
                  >
                </li>
                }
                @if(permissionService.hasModuleOrSubModuleAccess('purchase-order', 'purchase-order-list')){
                <li>
                  <a
                    routerLink="/admin-center/po-builder"
                    class="flex items-center gap-2"
                    routerLinkActive="active"
                    (click)="toggleMobileMenu()"
                  >
                    <svg
                      class="h-4 w-4"
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M12.542,6.667a.667.667,0,0,0,.646-.832A4.67,4.67,0,0,0,11.966,3.69L9.643,1.367A4.636,4.636,0,0,0,6.343,0H3.333A3.337,3.337,0,0,0,0,3.333v9.333A3.337,3.337,0,0,0,3.333,16h2a.667.667,0,1,0,0-1.333h-2a2,2,0,0,1-2-2V3.333a2,2,0,0,1,2-2h3.01c.109,0,.217.005.323.015V4.667a2,2,0,0,0,2,2ZM8,4.667V1.773a3.358,3.358,0,0,1,.7.537l2.323,2.323a3.363,3.363,0,0,1,.535.7H8.667A.668.668,0,0,1,8,4.667Zm7.415,3.253a2.047,2.047,0,0,0-2.829,0L8.115,12.391a2.651,2.651,0,0,0-.781,1.886v1.057A.667.667,0,0,0,8,16H9.057a2.649,2.649,0,0,0,1.885-.781l4.471-4.471a2,2,0,0,0,0-2.829ZM14.471,9.8,10,14.276a1.322,1.322,0,0,1-.943.391H8.666v-.391a1.324,1.324,0,0,1,.391-.943l4.472-4.471a.682.682,0,0,1,.943,0,.666.666,0,0,1,0,.943Z"
                        fill="currentColor"
                      />
                    </svg>
                    PO Builder</a
                  >
                </li>
                }
                @if (permissionService.hasModuleOrSubModuleAccess('contract', 'clause')) {
                <li>
                  <a
                    routerLink="/admin-center/clauses"
                    class="flex items-center gap-2"
                    routerLinkActive="active"
                    (click)="toggleMobileMenu()"
                  >
                    <svg
                      class="h-4 w-4"
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M2,0H0V16H16V0H2ZM14,14H2V2H14ZM4,4H12V5H4Zm0,2H12V7H4Zm0,2H10V9H4Zm0,2H8V11H4Z"
                        fill="currentColor"
                      />
                    </svg>
                    Clauses</a
                  >
                </li>
                }
              </ul>
            </div>
          </li>
          }
          </ul>
        <!-- profile -->
        <div class="absolute bottom-0 left-3.5">
          <div class="dropdown shrink-0">
            <div hlMenu class="!block">
              <button type="button" hlMenuButton class="group relative block">
                @if(profile_picture !== null && profile_picture ||
                userData?.profile_picture) {
                <img
                  class="h-8 w-8 rounded-full object-cover saturate-50 group-hover:saturate-100"
                  [src]="profileImageUrl"
                  alt=""
                  (error)="authService.onImageError($event, userData)"
                />
                } @else {
                <div
                  class="relative flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-gradient-to-br from-blue-500 to-purple-600 text-white shadow-lg transition-transform duration-300 group-hover:scale-105"
                >
                  <span
                    class="inline-flex h-8 w-8 items-center justify-center rounded-full text-[11px] font-semibold text-white"
                  >
                    {{ imageService.getInitials(userData?.name) }}
                  </span>
                </div>
                }
              </button>
              <ul
                *hlMenuItems
                @toggleAnimation
                class="absolute bottom-12 left-0 z-50 w-[230px] !py-0 font-semibold text-primary"
              >
                <li>
                  <div class="flex items-center px-4 py-4">
                    <div class="flex-none">
                      @if(profile_picture !== null && profile_picture ||
                      userData?.profile_picture) {
                      <img
                        class="h-10 w-10 rounded-full object-cover"
                        [src]="profileImageUrl"
                        alt=""
                        (error)="authService.onImageError($event, userData)"
                      />
                      } @else {
                      <div
                        class="relative flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-gradient-to-br from-blue-500 to-purple-600 text-white shadow-lg transition-transform duration-300 group-hover:scale-105"
                      >
                        <span
                          class="inline-flex h-8 w-8 items-center justify-center rounded-full text-[11px] font-semibold text-white"
                        >
                          {{ imageService.getInitials(userData?.name) }}
                        </span>
                      </div>
                      }
                    </div>
                    <div class="truncate ltr:pl-4 rtl:pr-4">
                      <h4 class="text-base">
                        {{ profile_name || userData?.name }}
                      </h4>
                      <a
                        class="text-black/60 hover:text-primary dark:text-dark-light/60 dark:hover:text-white"
                        href="javascript:;"
                        >{{ profile_email || userData?.email_id }}</a
                      >
                    </div>
                  </div>
                </li>
                <li>
                  <a
                    routerLink="/users/profile"
                    class="cursor-pointer border-t border-gray-200 pt-2 text-primary dark:border-white/10"
                  >
                    <svg
                      class="h-4.5 w-4.5 shrink-0 ltr:mr-2 rtl:ml-2"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="12"
                        cy="6"
                        r="4"
                        stroke="currentColor"
                        stroke-width="1.5"
                      />
                      <path
                        opacity="0.5"
                        d="M20 17.5C20 19.9853 20 22 12 22C4 22 4 19.9853 4 17.5C4 15.0147 7.58172 13 12 13C16.4183 13 20 15.0147 20 17.5Z"
                        stroke="currentColor"
                        stroke-width="1.5"
                      />
                    </svg>

                    View Profile
                  </a>
                </li>
                <li
                  class="border-t border-white-light dark:border-white-light/10"
                >
                  <a
                    (click)="signOut()"
                    class="cursor-pointer !py-3 text-primary"
                  >
                    <svg
                      class="h-4.5 w-4.5 shrink-0 rotate-90 ltr:mr-2 rtl:ml-2"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        opacity="0.5"
                        d="M17 9.00195C19.175 9.01406 20.3529 9.11051 21.1213 9.8789C22 10.7576 22 12.1718 22 15.0002V16.0002C22 18.8286 22 20.2429 21.1213 21.1215C20.2426 22.0002 18.8284 22.0002 16 22.0002H8C5.17157 22.0002 3.75736 22.0002 2.87868 21.1215C2 20.2429 2 18.8286 2 16.0002L2 15.0002C2 12.1718 2 10.7576 2.87868 9.87889C3.64706 9.11051 4.82497 9.01406 7 9.00195"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                      />
                      <path
                        d="M12 15L12 2M12 2L15 5.5M12 2L9 5.5"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    Sign Out
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
</div>
